import { render, staticRenderFns } from "./BkashPromotionEdit.vue?vue&type=template&id=3db70004&scoped=true&"
import script from "./BkashPromotionEdit.vue?vue&type=script&lang=js&"
export * from "./BkashPromotionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db70004",
  null
  
)

export default component.exports